import { formatDay, formatInr, mealsOf, slotLabel, type Meal, type Slot } from '@tiffinify/core';

export { formatDay, formatInr };

/** "Lunch", "Breakfast + lunch", "All 3 meals". */
export const mealsLabel = (slot: Slot): string => slotLabel(slot);

/** "1 breakfast", "3 lunches". */
export function mealCount(meal: Meal, n: number): string {
  const plural = meal === 'lunch' ? 'lunches' : `${meal}s`;
  return `${n} ${n === 1 ? meal : plural}`;
}

/** "Breakfast". */
export const mealName = (meal: Meal): string => meal.charAt(0).toUpperCase() + meal.slice(1);

/** What a plan's length is counted in: "lunches" for one meal a day, "days" for more. */
export function planUnit(slot: Slot, n: number): string {
  const m = mealsOf(slot);
  if (m.length > 1) return n === 1 ? 'day' : 'days';
  return mealCount(m[0]!, n).split(' ')[1]!;
}

export function endLabel(daysToEnd: number, endDate: string): string {
  if (daysToEnd < 0) return 'Ended';
  if (daysToEnd === 0) return 'Ends today';
  if (daysToEnd === 1) return 'Ends tomorrow';
  if (daysToEnd < 7) return `Ends ${formatDay(endDate).split(' ')[0]}`;
  return `Ends ${formatDay(endDate)}`;
}

/** "9845012345" from "919845012345" for form fields. */
export const localPhone = (p: string) => p.replace(/^91/, '');

export function errorMessage(e: unknown): string {
  return e instanceof Error ? e.message : 'Something went wrong';
}

/** "23:59" → "11:59 pm" */
export function clock12(hhmm: string): string {
  const [h = 0, m = 0] = hhmm.split(':').map(Number);
  return `${h % 12 || 12}:${String(m).padStart(2, '0')} ${h < 12 ? 'am' : 'pm'}`;
}
